import { useLocation } from 'react-router-dom'
import { FiChevronRight, FiHome } from 'react-icons/fi'
import './Breadcrumb.css'

const ROUTES = [
    // Início (cadastros básicos)
    { match: '/myclient', crumbs: ['Início', 'Meus Clientes'] },
    { match: '/client', crumbs: ['Início', 'Clientes'] },
    { match: '/provider', crumbs: ['Início', 'Fornecedores'] },
    { match: '/cloth', crumbs: ['Início', 'Tecidos'] },
    { match: '/category', crumbs: ['Início', 'Categoria'] },
    { match: '/sizegrid', crumbs: ['Início', 'Grade de Tamanhos'] },
    { match: '/commission', crumbs: ['Início', 'Comissão e Desconto'] },
    { match: '/additive', crumbs: ['Início', 'Aditivos'] },
    { match: '/colortype', crumbs: ['Início', 'Tipos de Cores'] },
    { match: '/simpleProduct', crumbs: ['Início', 'Produtos Simples'] },

    // Comercial
    { match: '/product/new', crumbs: ['Comercial', 'Produtos', 'Novo'] },
    { match: '/product', crumbs: ['Comercial', 'Produtos'] },
    { match: '/color/new', crumbs: ['Comercial', 'Catálogo de Cores', 'Novo'] },
    { match: '/color/edit', crumbs: ['Comercial', 'Catálogo de Cores', 'Editar'] },
    { match: '/color', crumbs: ['Comercial', 'Catálogo de Cores'] },
    { match: '/accessory/new', crumbs: ['Comercial', 'Acessórios', 'Novo'] },
    { match: '/accessory/edit', crumbs: ['Comercial', 'Acessórios', 'Editar'] },
    { match: '/accessory', crumbs: ['Comercial', 'Acessórios'] },
    { match: '/budget/pdf', crumbs: ['Comercial', 'Orçamentos', 'PDF'] },
    { match: '/mybudget', crumbs: ['Comercial', 'Meus Orçamentos'] },
    { match: '/budget', crumbs: ['Comercial', 'Orçamentos'] },

    // Administrador
    { match: '/system-user/new', crumbs: ['Administrador', 'Usuários', 'Novo'] },
    { match: '/system-user/edit', crumbs: ['Administrador', 'Usuários', 'Editar'] },
    { match: '/system-user/list', crumbs: ['Administrador', 'Usuários'] },
    { match: '/backup', crumbs: ['Administrador', 'Backup'] },
    { match: '/historic/list', crumbs: ['Administrador', 'Histórico'] },

    // fallback — garante que sempre há uma migalha nas páginas autenticadas
    { match: '/', crumbs: ['Início'] },
]

const HIDDEN = ['/login', '/register']

function Breadcrumb() {
    const { pathname } = useLocation()

    if (HIDDEN.includes(pathname)) return null

    const route = ROUTES.find(r => pathname.startsWith(r.match))
    if (!route) return null

    return (
        <nav className="breadcrumb-bar">
            <FiHome size={12} className="breadcrumb-home" />
            {route.crumbs.map((crumb, i) => (
                <span key={i} className="breadcrumb-item">
                    <FiChevronRight size={12} className="breadcrumb-sep" />
                    <span className={i === route.crumbs.length - 1 ? 'breadcrumb-current' : 'breadcrumb-parent'}>
                        {crumb}
                    </span>
                </span>
            ))}
        </nav>
    )
}

export default Breadcrumb
